import { LOGIN, LOGOUT, UPDATE_FIAT_OPTION } from "./auth.types";

const user_raw = localStorage.getItem("user_information");

const user = user_raw ? JSON.parse(user_raw) : {};
const INITIAL_STATE = {
  user,
  logged: false,
  token: user ? user.access : "",
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        user: action.payload,
        token: action.payload.SessionToken,
        logged: true,
      };

    case LOGOUT:
      return {
        ...state,
        user: null,
        token: "",
        logged: false,
      };
    case UPDATE_FIAT_OPTION:
      return {
        ...state,
        user: {
          ...state.user,
          ConvertCurrency: action.payload
        },
      };

    default:
      return state;
  }
};

export default reducer;
